import { SVGProps, ReactElement } from 'react';

export function LogoBl(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 600 160'
      xmlSpace='preserve'
      fill='currentColor'
      {...props}
    >
      <g>
        <path
          d='M54.1,159.4c-6.6,0-12.7-1.8-17.6-5.2c-7.3-5.1-10.6-11.6-10.6-20.8c0-14.7,15.4-35.5,49.7-35.5
		c7.3,0,17.7,4.3,17.8,4.4l0.1,0l0.1,0c0.1,0,14.6,4,14.6,4l4.6-1.3c0,0,0.7,3.6-0.1,5.2c-3.4,6.8-15.9,30-32.9,41.2
		c-1.9,1.2-3.7,2.3-5.6,3.1c-6.5,3-12.8,4.6-18.9,4.8C54.9,159.3,54.5,159.4,54.1,159.4z M73.2,105.7c-12.9,0-30.5,5.1-37.4,19.5
		c-2.5,5.3-2.7,11-0.5,15.6c3.4,7.2,9.3,10.5,18.4,10.5c0.5,0,0.9,0,1.4,0c4.9-0.2,10.2-1.5,15.6-4.1c16.4-7.6,29.2-29.1,32.7-36.7
		l0.2-0.5l-0.6-0.1c-1.1-0.2-2.3-0.5-3.7-0.7C93,107.7,83.2,105.7,73.2,105.7z'
        />
        <path
          d='M38.8,125.8c-13.6-2.8-24.3-8.7-31.1-17.1C1.4,101-1,91.7,0.9,82.5c2.4-11.9,13.4-26,36.6-26.5
		c0.5,0,1,0,1.4,0c4.4,0,9,0.5,13.7,1.5c26.3,5.3,51.8,33.8,59,42.4c1.3,1.5,1.8,3.5,1.4,5.5c-0.4,1.7-1.3,3.2-2.8,4.1
		c-0.2,0.1,0.6,1,0.4,1.1c-7.5,3.9-34.9,16.4-58.8,16.4C47.2,126.9,42.2,126.5,38.8,125.8z M39.1,64.1c-0.4,0-0.8,0-1.2,0
		c-6.3,0.2-11.9,1.5-16.7,4.1c-0.7,0.4-1.4,0.8-2.1,1.2c-5.5,3.6-9.1,8.7-10.3,14.7c-1.4,6.7,0.6,13.9,5.4,19.7
		c5.6,6.8,14.6,11.6,26.2,14c3,0.6,9.5,0.9,11.4,0.9c20.1,0,43.9-9.9,52.8-14.3l-0.5-1l-0.4-0.4C95.2,93.2,73,69.9,51,65.4
		C46.9,64.6,42.9,64.1,39.1,64.1z'
        />
        <path
          d='M104.8,110.4c-13.8-2.7-40.2-9.3-61.7-23.3C22.2,73.5,11.6,56.7,11.6,37.2
		c0-19.8,17.5-36.6,38.2-36.6c22.5,0,39.6,12.3,51,36.6C112.7,62.6,114,92,114,103.4c0,2.6,0,4.5-1.3,6.2c-0.9,1.2-3.5,1.3-4.4,1.3
		C107.4,110.8,106.1,110.7,104.8,110.4z M49.8,9c-16.3,0-29,12.1-29,28.2c0,43.1,65.2,61.1,85,65.6l0.5,0.1v-0.5
		C106.4,66.3,91.1,9,49.8,9z'
        />
        <g>
          <g>
            <path
              d='M128.7,129.9v-0.3c0-2.2,0.8-3.9,2.7-5.9l55-64.6h-50.8c-3,0-5.6-2.4-5.6-5.4s2.5-5.6,5.6-5.6
				h62.1c3.5,0,6.2,2.4,6.2,5.2v0.3c0,2.2-0.8,3.9-2.7,5.9l-55,64.6h53c3,0,5.6,2.5,5.6,5.4c0,3-2.5,5.6-5.6,5.6h-64.3
				C131.6,135.1,128.7,132.8,128.7,129.9z'
            />
            <path
              d='M220.1,53.9c0-3.5,2.9-6.6,6.4-6.6c3.7,0,6.6,2.9,6.6,6.6v75.5c0,3.7-2.7,6.6-6.4,6.6
				c-3.7,0-6.6-2.9-6.6-6.6V53.9z'
            />
            <path
              d='M254.7,53.9c0-3.5,2.9-6.6,6.4-6.6c3.7,0,6.6,2.9,6.6,6.6v9.4c5.7-9.4,14.8-17,29.8-17
				c21,0,33.3,14.1,33.3,34.8v48.3c0,3.7-2.9,6.6-6.4,6.6c-3.7,0-6.6-2.9-6.6-6.6V84.3c0-16.2-8.7-26.2-24.1-26.2
				c-15,0-26.1,10.9-26.1,27.3v44.1c0,3.7-2.7,6.6-6.4,6.6c-3.7,0-6.6-2.9-6.6-6.6V53.9z'
            />
            <path
              d='M350,53.9c0-3.5,2.9-6.6,6.4-6.6c3.7,0,6.6,2.9,6.6,6.6v9.4c5.7-9.4,14.8-17,29.8-17
				c21,0,33.3,14.1,33.3,34.8v48.3c0,3.7-2.9,6.6-6.4,6.6c-3.7,0-6.6-2.9-6.6-6.6V84.3c0-16.2-8.7-26.2-24.1-26.2
				c-15,0-26.1,10.9-26.1,27.3v44.1c0,3.7-2.7,6.6-6.4,6.6c-3.7,0-6.6-2.9-6.6-6.6V53.9z'
            />
            <path
              d='M446.4,53.9c0-3.5,2.9-6.6,6.4-6.6c3.7,0,6.6,2.9,6.6,6.6v75.5c0,3.7-2.7,6.6-6.4,6.6
				c-3.7,0-6.6-2.9-6.6-6.6V53.9z'
            />
            <path
              d='M563.8,129.4c0,3.7-2.9,6.6-6.4,6.6c-3.7,0-6.6-2.9-6.6-6.6v-11.8c-7.1,10.4-17.3,19.3-33.3,19.3
				c-20.9,0-41.6-16.5-41.6-45.1v-0.3c0-28.4,20.7-45.3,41.6-45.3c16.2,0,26.6,8.7,33.3,18.5v-13c0-3.7,2.7-6.6,6.4-6.6
				c3.7,0,6.6,2.9,6.6,6.6V129.4z M489.3,91.4v0.3c0,20.5,14.3,33.7,30.6,33.7c16.2,0,31.5-13.6,31.5-33.7v-0.3
				c0-20-15.3-33.5-31.5-33.5C503.1,57.9,489.3,70.3,489.3,91.4z'
            />
            <path
              d='M218.9,23c0-4.2,3.4-6.9,7.6-6.9c4.4,0,7.7,2.7,7.7,6.9v2.2c0,4-3.4,6.9-7.7,6.9
				c-4.2,0-7.6-2.9-7.6-6.9V23z'
            />
            <path
              d='M445.2,23c0-4.2,3.4-6.9,7.6-6.9c4.4,0,7.7,2.7,7.7,6.9v2.2c0,4-3.4,6.9-7.7,6.9
				c-4.2,0-7.6-2.9-7.6-6.9V23z'
            />
          </g>
          <g>
            <path d='M575.8,50.5h-4.6v-2.3h11.7v2.3h-4.6v12.1h-2.6V50.5z' />
            <path d='M585.6,48.1h2.7l4.4,6.8l4.4-6.8h2.7v14.4h-2.5V52.2l-4.5,6.8h-0.1l-4.5-6.7v10.3h-2.5V48.1z' />
          </g>
        </g>
      </g>
    </svg>
  );
}
